import DrugScanned from '../components/popups/drugScanned/DrugScanned';
import models from '../model/models';
import mainAPI from '../api/MainAPI';
import NewDrugPopup from '../components/popups/newDrugPopup/NewDrugPopup';
import verifyController from './verifyController';
import utils from '../utils/utils';
import toasts from '../utils/toasts';
import cloneDeep from 'lodash.clonedeep';
import getLocation from '../utils/getLocation.js';
import { getLastLocation } from '../utils/getLocation';
import objUtils from '../utils/objUtils';
import scanViewController from './scanViewController';
import dashboardController from "./dashboardController";
import {PopupAnimationMs} from "../utils/animationConstants";

let DrugScanController = function () {
	this.start = (drug) => {
    this.creatingDrugs = false;
		this.currentDrug = {};
		this.drugs = [];
		if (drug) return;
		this.showScanner();
		getLocation();
	};
	this.showScanner = () => {
		scanViewController.showScanner(
			'Scan a Drug',
			'Place the scan area on the code',
			this._handleScan,
			this._showNewDrugPopup
		);
	};

	this._handleScan = async (text) => {
		let drug = await mainAPI.drug.find_by_barcode({ barcode_id: text });
		if (drug) {
      if(this.creatingDrugs && this.drugs?.length > 0){
        const message = `This code has already been used ${text}. Please use another code.`;
        mainAPI.error_log.create({type:'scannedExitingDrugWhileCreatingDrugs', message})
        return toasts.error(message, 3000);
      }
			return this.foundDrug(drug);
		}
		this.drugNotFound(text);
	};

	this.drugNotFound = (text) => {
    if(this.drugs?.length == 0){
      this.creatingDrugs = true;
    }
		let user = models.user.getCurrent();
		let user_group = models.user_group.obj();
		if (user_group?.allow_users_to_create_drugs || user.role === 'admin') {
			this.currentDrug.barcode_id = text;
			this._onAddAnother(this.currentDrug);
		} else {
			toasts.error('Drug not found, You are not allowed to create drugs.');
		}
	};

	this.foundDrug = (drug) => {
		scanViewController.hideScanner(PopupAnimationMs * 2);
		scanViewController.hideMainViewDuringAnimation();
		window.popupController.show(DrugScanned, { value: drug, onCancel: this.start });
	};

	this._onAddAnother = (drug) => {
		this.drugs.push(drug);
		let drugs = objUtils.to_obj(this.drugs, 'barcode_id');
		this.drugs = objUtils.to_array(drugs);
		scanViewController.setDrugs(this.drugs, 'Create');
		this.currentDrug = cloneDeep(drug);
		this.showScanner();
	};

	this._showNewDrugPopup = (drug, drugBarcodes) => {
		scanViewController.hideMainViewDuringAnimation();
		window.popupController.show(NewDrugPopup, {
			state: {
				value: {...drug, drug_box_id: drug.drug_box_id || localStorage.lastBoxId},
				drugBarcodes,
			},
			onDoneCreating: this._onDoneCreating
		});
		scanViewController.hideScanner(PopupAnimationMs * 2);
	};

	this._onDoneCreating = (drug) => {
		this.updateDrugs(drug);
		const drugType = models.drug_type.obj(drug.type);
		if(drugType?.categories?.includes('Non-Controlled Substance')){
			return this._createDrugs({});
		}
		verifyController.start(async (verify_obj) => {
			await this._createDrugs(verify_obj);
		});
	};
	this.updateDrugs = (drug) => {
		for (let i in this.drugs) {
			for (let j in drug) {
				if (j === 'barcode_id') continue;
				this.drugs[i][j] = drug[j];
			}
		}
	};

	this._createDrugs = async (verify_obj) => {
		let promises = [];
		for (let i in this.drugs) {
			let drug = this.drugs[i];
			drug.witness_id = verify_obj.witness_id;
			drug.witness_biometric_guid = verify_obj.guid;
			drug.guest_verify__signature_img = verify_obj.guest_verify__signature_img;
			drug.guest_verify__name = verify_obj.guest_verify__name;
			drug.guest_verify__license_number = verify_obj.guest_verify__license_number;
			drug.guest_verify__title = verify_obj.guest_verify__title;
			promises.push(this._createDrug(drug));
		}
		const type = this.drugs[0].type;
		const drugType = models.drug_type.obj(type) || {};

		window.popupController.hideAll();
		const responses = await Promise.all(promises);
		const nonEmptyResponses = responses.filter(r=>Boolean(r));
		if (nonEmptyResponses.length === 0) {
			toasts.error('Error creating ' + drugType.name || type);
		} else if (nonEmptyResponses.length === 1) {
			toasts.show('Created a vial of ' + drugType.name || type);
		} else {
			toasts.show('Created ' + nonEmptyResponses.length + ' vials of ' + drugType.name || type);
		}
		dashboardController.refresh(this.drugs[0].drug_box_id);
	};

	this._createDrug = async (drug) => {
		drug.expiration_date = utils.client_to_server_date(drug.expiration_date);
		let location = getLastLocation();
		drug.lat = location.lat;
		drug.lon = location.lon;
		return mainAPI.drug.create(drug);
	};
};

let drugScanController = new DrugScanController();
export default drugScanController;
